export const companyWorkflowGuide =
  'How companies work: (1) the companies page shows a tree in context.company_list; ' +
  '(2) goto_company selects a company by id (also navigates to its detail form); ' +
  '(3) current_company_form_set_fields edits the open company in memory; ' +
  '(4) current_company_form_save persists. create_company creates a new company immediately. ' +
  'The form also holds the brand colours (primary and accent, as rgba strings). ' +
  'Only *_save and create_company persist; opening a company never does.';
